import React from 'react';

const LockIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17.1289C11.4696 17.1289 10.9609 16.9182 10.5858 16.5431C10.2107 16.168 10 15.6593 10 15.1289C10 14.0189 10.89 13.1289 12 13.1289C12.5304 13.1289 13.0391 13.3396 13.4142 13.7147C13.7893 14.0898 14 14.5985 14 15.1289C14 15.6593 13.7893 16.168 13.4142 16.5431C13.0391 16.9182 12.5304 17.1289 12 17.1289ZM18 20.1289V10.1289H6V20.1289H18ZM18 8.12891C18.5304 8.12891 19.0391 8.33962 19.4142 8.71469C19.7893 9.08977 20 9.59847 20 10.1289V20.1289C20 20.6593 19.7893 21.168 19.4142 21.5431C19.0391 21.9182 18.5304 22.1289 18 22.1289H6C5.46957 22.1289 4.96086 21.9182 4.58579 21.5431C4.21071 21.168 4 20.6593 4 20.1289V10.1289C4 9.01891 4.89 8.12891 6 8.12891H7V6.12891C7 4.80282 7.52678 3.53105 8.46447 2.59337C9.40215 1.65569 10.6739 1.12891 12 1.12891C12.6566 1.12891 13.3068 1.25824 13.9134 1.50951C14.52 1.76078 15.0712 2.12908 15.5355 2.59337C15.9998 3.05767 16.3681 3.60886 16.6194 4.21549C16.8707 4.82212 17 5.4723 17 6.12891V8.12891H18ZM12 3.12891C11.2044 3.12891 10.4413 3.44498 9.87868 4.00759C9.31607 4.5702 9 5.33326 9 6.12891V8.12891H15V6.12891C15 5.33326 14.6839 4.5702 14.1213 4.00759C13.5587 3.44498 12.7956 3.12891 12 3.12891Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LockIcon;
